module.exports = {
  /**
   * Brand colors
   * @type {String}
   */
  BRAND_GREEN: '#00cc83',
  BRAND_BLUE: '#204ecf',
  BRAND_GREY: '#c4c6ca',

  /**
   * Auxiliary colors
   * @type {String}
   */
  SUBTLE_GREY: '#ececec',
  LIGHT_GREY: '#717e8f',
  DARK_GREY: '#485465'
}



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/chart/config/colors.js